import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { InView } from "react-intersection-observer";
import Box from "react-raster";
import Container from "../Container";
import { H2, Copy, AccentTitle, Eyebrow } from "../Typography";
import { Meta, SubTitle } from "../ClientLogos";
import isMobile from "../../isMobile";
import { getImage, GatsbyImage } from "gatsby-plugin-image";

const AnimationKeyFrames = createGlobalStyle`
  @keyframes fadeInAnimation { 
    0% { 
      opacity: 0;
      transform: translateY(100px);
    } 
    100% { 
      opacity: 1;
      transform: translateY(0);
    } 
  }
`;

const Wrapper = styled.div`
  background-image: url(${({ $image }) => $image});
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

const LogoImage = styled(GatsbyImage)`
  max-width: 100%;
  max-height: 180px;
`;

const CompanyName = styled(AccentTitle)`
  border-top: 1px solid ${({ theme }) => theme.colours.white};
`;

const LogosBox = styled(Box)`
  opacity: 0;
  animation: ${({ $animated }) =>
    $animated === "true" && "fadeInAnimation ease 0.5s"};
  animation-fill-mode: forwards;

  @media (prefers-reduced-motion) {
    opacity: 1;
    animation: none;
  }
`;

const Logo = styled.div`
  flex: 0 1 180px;
`;

function DescriptionWithClientLogos({
  title,
  description,
  image,
  clientLogos,
  hideTitle,
  eyebrow,
  hasBottomMargin,
  hasTopMargin,
}) {
  const parsedImage = getImage(image);

  console.log({ hasBottomMargin, hasTopMargin });

  return (
    <Wrapper
      $image={parsedImage}
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <AnimationKeyFrames />
      <Container hasBottomMargin={hasBottomMargin}>
        <Box cols={[6, 6, 5]} marginTop={1}>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          {title && !hideTitle && (
            <H2 $colour={parsedImage && "white"}>{title}</H2>
          )}
          <Copy colour={parsedImage && "white"}>{description}</Copy>
        </Box>
        <InView triggerOnce threshold={isMobile() ? 0 : 0.3}>
          {({ inView, ref }) => (
            <LogosBox
              cols={[6, 5, 3]}
              marginLeft={[0, 0, 2]}
              marginTop={1}
              $animated={inView.toString()}
            >
              <div ref={ref}>
                {clientLogos?.map((logoObj) => {
                  const { id, logo, companyName, subTitle } = logoObj;
                  return (
                    <Logo key={id}>
                      <LogoImage image={getImage(logo)} alt={companyName} />
                      <Meta>
                        <CompanyName>{companyName}</CompanyName>
                        <SubTitle>{subTitle}</SubTitle>
                      </Meta>
                    </Logo>
                  );
                })}
              </div>
            </LogosBox>
          )}
        </InView>
      </Container>
    </Wrapper>
  );
}

export default DescriptionWithClientLogos;
